import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var payResultRoute = [{
  path: "payResult/:payType/:orderId",
  name: "payResult",
  component: function component() {
    return import("./pay-result.vue");
  }
}];